export default "__VITE_ASSET__XT7ETsME__"